import { FeatureFlagService } from "../services/feature-flag.service";

/**
 * Factory function for initializing feature flags
 * @param featureFlagService the {@link FeatureFlagService}
 */
export function initializeFeatureFlags(
  featureFlagService: FeatureFlagService
): () => Promise<boolean> {
  return (): Promise<boolean> => featureFlagService.initialize();
}
